export enum AlarmType {
    Speed = "speed",
    Stoppage = "stoppage",
    Crosstrack = "crosstrack",
    NoPlan = "no-plan",
    HeavyWeather = "heavyweather",
    ParametricRoll = "parametricroll",
    WRSafetyAlert = "safetycheck-alert",
    WRPerformanceAlert = "performance-alert",
    WRReject = "wr_reject"
}

export enum RouteTypeOption {
    StarRoute = "star-route",
    WniRoute = "wni-route",
    OwnRoute = "own-route"
}

export enum RouteTypeOptionComingFromApi {
    StarRoute = "BPR",
    WniRoute = "WR",
    OwnRoute = "UserRoute"
}

export type AlarmDetection = {
    id: number;
    createdAt: string;
    location: {
        geometry: {
            coordinates: [number, number];
        };
    };
    metadata: {
        speed?: number // actual speed at this point in time (timestamp)
        speedDiff?: number  //this is the diff between speed & legSpeed
        requiredSpeed?: number // legSpeed is the required speed by the leg
        planId?: number
        planSource?: string
        voyageId?: string
        offTrackDistance?: number
    };
}

export interface AlarmLog {
    id: number,
    alarmId: number,
    createdAt: string,
    toState: AlarmState,
    fromState: AlarmState,
    note: string,
    reason: string,
    userId: string,
    reasonSource? : string,
    userData?: {
        displayName?: string,
        email?: string
    }
}

export enum AlarmState {
    InProgress = 'in-progress',
    Active = 'active',
    Acknowledged = "acknowledged",
    Pending = "pending",
    Cancelled = "cancelled",
    Ended = "ended"
}

export enum FleetAlarmAudience {
    VoyageExecution = 1,
    Cenfltops = 2
}
export interface Alarm {
    id: number;
    imo: number;
    alarmType: AlarmType;
    startTs: string;
    endTs: string;
    alarmState: AlarmState;
    alarmDetections: AlarmDetection[];
    mutedUntil: string | null;
    alarmLogs: AlarmLog[];
    userData?: {
        displayName?: string,
        email?:string
    }
    snoozedTime?: string;
    created_at: string;
}

export const StaticInfoForAlarms: Record<AlarmType, string> = {
    speed: "Speed 1.5 kt from plan for more than 2 hours",
    stoppage: "Below 6 kt for more than 1 hour",
    crosstrack: "More than 10 NM from plan",
    "no-plan": "",
    heavyweather:"Risk of heavy weather",
    parametricroll:"Risk of parametric roll",
    "safetycheck-alert":"Safety check alert",
    "performance-alert":"Performance alert",
    "wr_reject":"Weather routing rejected"

} as const

export enum AlarmAcceptanceSource {
    Vessel = "vessel",
}   